import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tips-bg",
  "use": "icon-tips-bg-usage",
  "viewBox": "0 0 232 96",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 232 96\" id=\"icon-tips-bg\"><path d=\"M3 1.075v85.867l35.586-18.4h13.79L42.391 96h18.4l9.985-27.464.455-.006C84.427 68.127 95 57.303 95 44.01c0-13.55-10.984-24.534-24.533-24.534H38.589L3 1.075zm9.2 15.114l24.533 12.68v30.277L12.2 71.828V16.19z\" fill=\"#F4F5F9\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol